<template>
  <div class="textarea-container" :class="{ disabled: disabled }">
    <textarea
      :value="modelValue"
      :placeholder="placeholder"
      :maxlength="maxLength"
      :rows="rows"
      :style="{ width: width }"
      :disabled="disabled"
      class="action-textarea"
      @input="handleInput"
    ></textarea>
    <div class="textarea-footer">
      <span class="character-count">{{ characterCount }}/{{ maxLength }} characters</span>
      <button
        v-if="modelValue && !disabled"
        class="clear-btn"
        type="button"
        @click="handleClear"
      >
        Clear
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TextareaWithClear',
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Please Input'
    },
    maxLength: {
      type: Number,
      default: 1000
    },
    rows: {
      type: Number,
      default: 4
    },
    width: {
      type: String,
      default: '100%'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'clear'],
  computed: {
    characterCount() {
      return this.modelValue ? this.modelValue.length : 0;
    }
  },
  methods: {
    handleInput(event) {
      this.$emit('update:modelValue', event.target.value);
    },
    handleClear() {
      this.$emit('update:modelValue', '');
      this.$emit('clear');
    }
  }
};
</script>

<style scoped>
/* Textarea Container */
.textarea-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  background: #FFFFFF;
  border: 1px solid #C9C9C9;
  border-radius: 4px;
  padding: 8px 12px;
  transition: border-color 0.2s ease;
}

.textarea-container:focus-within {
  border-color: #004879;
}

.textarea-container.disabled {
  background: #F5F5F5;
  border-color: #E0E0E0;
  cursor: not-allowed;
}

.textarea-container.disabled:focus-within {
  border-color: #E0E0E0;
}

/* Textarea */
.action-textarea {
  width: 100%;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 300;
  line-height: 18px;
  color: #333;
  border: none;
  outline: none;
  resize: none;
  min-height: 72px;
}

.action-textarea::placeholder {
  color: #999;
}

.action-textarea:disabled {
  background: #F5F5F5;
  color: #999;
  cursor: not-allowed;
}

/* Footer */
.textarea-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  margin-top: 4px;
}

.character-count {
  flex: 1;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 300;
  line-height: 18px;
  color: #999;
}

/* Clear Button */
.clear-btn {
  padding: 4px 10px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: #1E4670;
  background: transparent;
  border: none;
  cursor: pointer;
  text-decoration: underline;
  text-decoration-skip-ink: none;
  text-underline-position: from-font;
}

.clear-btn:hover {
  color: #004879;
}
</style>
